import { Button, ButtonProps } from '@mui/material'
import { produceWithPatches } from 'immer';
import { ReactNode } from 'react';

export interface IConfirmButtonProps {
  children: ReactNode,
  loading?: boolean,
  disabled?: boolean
}

export default function ConfirmButton({ children, disabled, loading, ...rest }: IConfirmButtonProps & ButtonProps) {
  return (
    <Button variant="contained" disabled={loading || disabled}  {...rest} sx={{ minWidth: '92px', ...rest?.sx }}>{loading ? 'สักครู่' : children}</Button>
  );
}
